import Itsolutions from '../../components/itsolutions/itsolutions';

const ItsolutionsPage = () => {
  return <Itsolutions />;
};

export default ItsolutionsPage;
